import React, {Component} from 'react';
import {Modal, ModalBody, ModalHeader} from 'reactstrap';
import imagesGallery from "../externalData/bgImgGallery";
import RenderImageItem from "./RenderImageItem";

class ModalGallery extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isModalOpen: false
        };

        this.toggleModal = this.toggleModal.bind(this);
    }

    toggleModal() {
        this.setState({
            isModalOpen: !this.state.isModalOpen
        });
    }

    onModalClose = () => {
        console.log('onModalClose_Gallery');
        if(document.fullscreen) {
            document.getElementById('root').style.display = 'flex';
        }
    };

    render() {
        const images = imagesGallery.map((item) =>
            <RenderImageItem
                key={item.id}
                image={item}
                onClick={Boolean(this.state.isModalOpen) ? this.props.onClick : null}
            />
        );

        return (
            <Modal size='lg' isOpen={this.state.isModalOpen} toggle={this.toggleModal} centered={true} onClosed={this.onModalClose} onExit={this.onModalClose}>
                <ModalHeader toggle={this.toggleModal}><span>{this.props.translation.t('MODAL_LOCAL_STORAGE_PHOTO_TITLE')}</span></ModalHeader>
                <ModalBody>
                    <div className="imageList">
                        {images}
                    </div>
                </ModalBody>
            </Modal>
        );
    }
}

export default ModalGallery;